{
  "mapTitle": "Evacuation & safety map",
  "mapLead": "Open evacuation sites near you, hazard areas and road closures.",
  "mapLabel": "Map of evacuation sites, hazard areas and road closures",
  "whereAmI": "Where am I?",
  "nearestTitle": "Nearest open sites",
  "nearestFrom": "Straight-line distance from your location.",
  "nearestFromBarangay": "Open sites in {barangay} are listed first.",
  "nearestFromTap": "Distance from the spot you tapped on the map.",
  "pickBarangayHint": "Location is off. Choose your barangay, or tap the map where you are.",
  "noOpenSites": "No evacuation site is open right now. Follow official advisories, and in an emergency call 911.",
  "directions": "Get directions",
  "directionsNote": "Directions open in Google Maps and do not account for road closures or hazards. Follow official instructions.",
  "distanceAway": "{distance} away",
  "allSites": "All evacuation sites",
  "emptySites": "No evacuation sites have been published yet. In an emergency, call 911.",
  "status_open": "Open",
  "status_full": "Full",
  "status_closed": "Closed",
  "occupancy": "{occupancy} of {capacity} people",
  "occupancyNoCapacity": "{occupancy} people",
  "facilities": "Facilities",
  "contact": "Contact",
  "layers": "Map layers",
  "layerSites": "Evacuation sites",
  "layerHazards": "Hazard areas",
  "layerClosures": "Road closures",
  "layerReports": "Active emergency reports (staff only)",
  "legend": "Legend",
  "sourceDated": "Source: {source}, {date}",
  "source": "Source: {source}",
  "hazard_landslide": "Landslide",
  "hazard_flood": "Flood",
  "hazard_other": "Other hazard",
  "closureUntil": "Closed until {date}",
  "youAreHere": "You are here",
  "accuracy": "Accurate to about {meters} m",
  "liveNote": "Occupancy and status update live.",
  "showOnMap": "Show on map",
  "siteMarker": "{name}, {status}",
  "theLgu": "the LGU",
  "offlineTitle": "Map for offline use",
  "offlineHelp": "Saves this town's map on your phone so it works with no signal, for example during a typhoon. Use Wi-Fi if you can.",
  "offlineSave": "Save map for offline use",
  "offlineSize": "about {size}",
  "offlineSaving": "Saving map… {percent}",
  "offlineSavedOn": "Saved on this phone on {date} ({size}).",
  "offlineDelete": "Remove offline map",
  "offlineUpdate": "Update",
  "offlineError": "The map could not be saved: {error}",
  "offlineSuggest": "Emergency mode is on. Save the map now so it keeps working without signal.",
  "offlineDone": "Map saved for offline use.",
  "offlineRemoved": "Offline map removed.",
  "hotlinesTitle": "Emergency hotlines",
  "hotlinesLead": "Call 911 first for police, fire and medical emergencies.",
  "call911Body": "Police, fire and medical emergencies. Calling is the fastest way to get help.",
  "localHotlines": "Local hotlines",
  "emptyHotlines": "No local hotlines have been published yet. In an emergency, call 911.",
  "callNumber": "Call {number}",
  "emergencyModeTitle": "Emergency mode is on",
  "emergencyModeSince": "Since {date}",
  "findNearest": "Find the nearest open evacuation site",
  "openMap": "Open the evacuation map",
  "seeAllHotlines": "All hotlines",
  "adminTitle": "Safety map",
  "adminLead": "Evacuation sites, hazard areas and road closures shown to residents.",
  "tabSites": "Evacuation sites",
  "tabLayers": "Map layers",
  "addSite": "Add evacuation site",
  "editSite": "Edit evacuation site",
  "siteName": "Site name",
  "siteLocation": "Location on the map",
  "siteLocationHint": "Drag the pin or tap the map at the site's entrance.",
  "pinRequired": "Place the pin on the map.",
  "capacity": "Capacity (people)",
  "currentOccupancy": "People there now",
  "facilitiesHint": "Tap a suggestion or type your own.",
  "addFacility": "Add",
  "facilityName": "Other facility",
  "removeFacility": "Remove {name}",
  "contactName": "Contact person",
  "contactPhone": "Contact number",
  "notes": "Notes for residents",
  "published": "Show to residents",
  "publishedHint": "Unpublished sites are visible only to staff.",
  "unpublished": "Not shown to residents",
  "deleteSite": "Delete site",
  "confirmDeleteSite": "Delete {name}? This cannot be undone.",
  "siteSaved": "Site saved.",
  "siteDeleted": "Site deleted.",
  "addPerson": "Add one person at {name}",
  "removePerson": "Remove one person at {name}",
  "addTen": "Add ten people at {name}",
  "occupancyLabel": "People at {name}",
  "statusOf": "Status of {name}",
  "autoFull": "Marked full automatically when people reach capacity.",
  "addHazard": "Add hazard layer",
  "addClosure": "Add road closure",
  "editLayer": "Edit layer",
  "layerTitle": "Title",
  "hazardType": "Hazard type",
  "sourceName": "Source",
  "sourceNameHint": "Where the data comes from, as confirmed by MDRRMO, e.g. PHIVOLCS GeoRiskPH or Project NOAH.",
  "sourceDate": "Source date",
  "sourceDateRequired": "Add the date of the source data.",
  "geojsonFile": "GeoJSON file",
  "geojsonHint": "A .geojson file with polygons, up to 10 MB.",
  "geojsonKeep": "Leave empty to keep the current shapes.",
  "geojsonRequired": "Choose a GeoJSON file.",
  "geojsonInvalid": "This file is not valid GeoJSON: {error}",
  "geojsonTooBig": "This file is larger than 10 MB. Simplify the shapes and try again.",
  "featuresLoaded": "{count} shapes loaded.",
  "preview": "Preview",
  "closureDraw": "Tap the map along the closed road to draw it.",
  "closurePoints": "{count} points",
  "undoPoint": "Undo last point",
  "clearPoints": "Clear",
  "closureNeedsLine": "Tap at least two points on the map.",
  "validFrom": "Closed from",
  "validUntil": "Closed until",
  "validHint": "Leave empty if not known. Closures disappear from the public map after the end time.",
  "visibleToggle": "Visible to residents",
  "hidden": "Hidden",
  "shapes": "{count} shapes",
  "deleteLayer": "Delete layer",
  "confirmDeleteLayer": "Delete {name}?",
  "emptyLayers": "No hazard areas or road closures yet.",
  "layerSaved": "Layer saved.",
  "layerDeleted": "Layer deleted.",
  "fallbackMissing": "The backup map (MAP_FALLBACK_PMTILES_URL) is not set up, so residents' maps can't work offline or when OpenFreeMap is down. Ask IT to run npm run map:extract.",
  "emTitle": "Emergency mode",
  "emLead": "During a disaster, emergency mode shows a red banner to every resident and puts advisories, hotlines and the nearest-site finder at the top of the home screen.",
  "emIsOn": "Emergency mode is ON",
  "emIsOff": "Emergency mode is off",
  "emMessage": "Message to residents",
  "emMessageHint": "Short and clear, e.g. \"Typhoon Signal No. 3. Evacuation sites are open. Avoid landslide-prone roads.\"",
  "emTurnOn": "Turn on emergency mode",
  "emTurnOff": "Turn off emergency mode",
  "emUpdateMessage": "Update message",
  "emConfirmOnTitle": "Turn on emergency mode?",
  "emConfirmOnBody": "Every resident will see a red emergency banner right away.",
  "emConfirmOffTitle": "Turn off emergency mode?",
  "emConfirmOffBody": "The emergency banner will disappear for everyone.",
  "emStartedAt": "Turned on {date}",
  "emDone": "Emergency mode updated.",
  "confirm": "Confirm",
  "hotAdminTitle": "Hotlines",
  "hotAdminLead": "Local emergency and office numbers. 911 is always shown first and cannot be removed.",
  "addHotline": "Add hotline",
  "editHotline": "Edit hotline",
  "hotName": "Name",
  "hotAgency": "Agency or office",
  "hotNumbers": "Phone numbers",
  "hotNumber": "Number {n}",
  "addNumber": "Add another number",
  "removeNumber": "Remove number {n}",
  "hotNote": "Note",
  "hotPublished": "Show to residents",
  "moveUp": "Move {name} up",
  "moveDown": "Move {name} down",
  "confirmDeleteHotline": "Delete {name}?",
  "hotlineSaved": "Hotline saved.",
  "hotlineDeleted": "Hotline deleted.",
  "builtIn911": "911 · always first",
  "emptyHotlinesAdmin": "No local hotlines yet. Add the MDRRMO, police, fire and health numbers confirmed by each office."
}
